import React, {lazy, Suspense} from 'react';
import Section from '../../../Components/Containers/Section';
import Loading from '../../../Components/Loading';
import { useRecentThreads, useUnreadThreads } from '../../../Data/Messages';
import { Link } from 'react-router-dom';
import { classNames, getEntityLink } from '../../../Services/helpers';
import Icon from '../../../Components/Icons/Icon';
import { usePreference } from '../../../Data/Preference';
// import Message from '../../../Components/Threads/Message';

const Message = lazy(() => import(/* webpackPreload: true, webpackChunkName: "ui-components" */'../../../Components/Threads/Message'));

const Threads = () => {
    const [show, setShow] = usePreference('home.threads.show', 'Unread');
    const {unread, isLoading: isUnreadLoading} = useUnreadThreads();
    const {recent, isLoading: isRecentLoading} = useRecentThreads();

    const threads = (show === 'Unread') ? unread : recent;
    const isLoading = isUnreadLoading || isRecentLoading;

    return <Section title="Messages"
            isLoading={threads && isLoading}
            options={['Unread', 'Recent']}
            optionsVal={show}
            optionsCallback={setShow}
        >
        {threads ? <Inner {...{threads, show}} /> : <Loading size="4x" center />}
    </Section>
}

const Inner = ({threads, show}) => {
    const [count, setCount] = usePreference('home.threads.count', 2);

    if (!threads || threads.length === 0) {
        return <p className="text-muted text-center">You have no {show.toLowerCase()} messages.</p>
    }

    return <>
        <div className="flex flex-col divide-y">
            {threads.slice(0, count).map(thread => <div key={thread.id} className="py-2 first:pt-0">
                <Link to={getEntityLink(thread.entityModel, thread.entityId)} className="flex flex-row">
                    <div className="flex flex-col space-y-1 grow">
                        <strong>{thread.contactName}</strong>
                        <div>
                            <Suspense fallback={null}>
                                <Message message={thread.messages?.[0] ?? null} isLast={true} />
                            </Suspense>
                        </div>
                    </div>
                    <div className="grow-0 shrink-0 flex items-center">
                        <Icon icon="RightChevron" className="fill-brand" size="2x" />
                    </div>
                </Link>
            </div>)}
        </div>

        {show.toLowerCase() === 'recent' && <CountOptions {...{count, setCount}} />}
    </>
}

const CountOptions = ({count, setCount}) => {
    return <p className="text-sm text-muted flex flex-row-reverse my-2">
        <CountBtn {...{count, setCount, num: 20}} />
        <CountBtn {...{count, setCount, num: 10}} />
        <CountBtn {...{count, setCount, num: 5}} />
        <CountBtn {...{count, setCount, num: 2}} />
        <span className="inline-block px-2 py-1">Show</span>
    </p>
}

const CountBtn = ({num, count, setCount}) => {
    return <button onClick={() => setCount(num)}
        className={classNames(
            'inline-block px-2 py-1 cursor-pointer',
            count === num ? 'text-brand font-bold' : 'text-muted',
            num !== 2 ? 'border-l' : '',
        )}
    >
        {num}
    </button>
}

export default Threads;
